const deDE = {
    'global': {
        'default': {
            'refresh': 'Aktualisieren',
            'all': 'Alle',
            'back': 'Zurück',
            'edit': 'Bearbeiten',
            'delete': 'Löschen',
            'cancel': 'Abbrechen',
            'save': 'Speichern',
        },
    },
    'TopdataContactLoginSW6': {
        'regLog': {
            'module': {
                'name': 'Registrierungsversuche',
                'title': 'Fehlgeschlagene Registrierungsversuche',
                'description': 'Protokoll fehlgeschlagener Registrierungs- und Checkout-Versuche aufgrund doppelter E-Mail-Adressen',
            },
            'list': {
                'title': 'Fehlgeschlagene Registrierungsversuche',
                'filter': {
                    'attemptType': 'Versuchstyp',
                    'conflictType': 'Konflikttyp',
                },
                'column': {
                    'email': 'E-Mail',
                    'attemptType': 'Versuchstyp',
                    'conflictType': 'Konflikttyp',
                    'createdAt': 'Datum',
                },
            },
            'detail': {
                'title': 'Registrierungsversuch',
                'card': {
                    'logInfo': 'Versuchsdetails',
                    'customerInfo': 'Kundeninformationen',
                },
                'label': {
                    'email': 'E-Mail-Adresse',
                    'attemptType': 'Versuchstyp',
                    'conflictType': 'Konflikttyp',
                    'createdAt': 'Datum',
                    'ipAddress': 'IP-Adresse',
                    'userAgent': 'User Agent',
                    'customerName': 'Kundenname',
                    'customerEmail': 'Kunden-E-Mail',
                },
                'notFound': 'Eintrag nicht gefunden',
            },
            'attemptType': {
                'guest_checkout': 'Gast-Bestellung',
                'registration': 'Registrierung',
                'contact_create': 'Kontakterstellung',
                'contact_email_change': 'Kontakt-E-Mail-Aenderung',
            },
            'conflictType': {
                'customer_exists': 'Kunde existiert',
                'contact_exists': 'Kontakt existiert',
            },
        },
    },
};

export default deDE;
